import { BuildingLibraryIcon, XCircleIcon, CheckIcon, XMarkIcon } from '@heroicons/react/24/outline'

function classNames(...classes){
  return classes.filter(Boolean).join(' ')
}

export default function DatagridDetalleCertificacion({ data, month, year, recordsPerPage, currentPage, totalData }) {

    const relativeIndex = (idx) => {
      return (idx + 1) + (recordsPerPage * (currentPage - 1))
    }

    return (
      <div className="px-4 sm:px-6 lg:px-8 bg-primarioMira pt-5 rounded-lg shadow-xl">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <div className='flex flex-row'>
                <BuildingLibraryIcon
                  className='h-14 w-14 mr-2 text-secundario'
                />
              <div>
                <h3 className="text-lg font-semibold text-white">Detalle - Certificación de facturas</h3>
                <h4 className="text-lg font-semibold text-white">{month} {year}</h4>
              </div>
            </div>
            <p className="mt-2 text-sm text-grisMira">
              Lista detallada de certificación de facturas.
            </p>
          </div>
        </div>
        <div className="mt-8 flex flex-col">
          <div className="-my-2 -mx-4 overflow-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full align-middle">
              <div className="h-auto shadow ring-1 ring-black ring-opacity-5">
                <table className="min-w-full divide-y divide-grisMira p-5">
                  <thead className="sticky top-0 bg-secundarioMira">
                    <tr className="divide-x divide-grisMira">
                      <th scope="col" className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-grisMira sm:pl-6">
                        ID
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                        Empresa
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                        Fecha Transacción
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                        ID
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                        <p>Transacciones</p> <p>SAT</p>
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-white">
                      <p>Transacciones</p> <p>Certificados</p>
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-sm font-semibold text-white  text-center">
                      <p className='text-xl'>Σ</p><p> SAT</p>
                      </th>
                      <th scope="col" className="py-3.5 pl-4 pr-4 text-center text-sm font-semibold text-white sm:pr-6">
                      <p className='text-xl'>Σ</p><p> Recibos</p>
                      </th>
                      <th scope="col" className="px-4 py-3.5 text-center text-sm font-semibold text-white">
                      <p className='text-xl'>Σ</p><p>Certificación</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-grisMira bg-primarioMira">
                    {data?.map((transaction, index) => {

                      let cuadra
                      let uno = (transaction.TotalTransacciones === transaction.TotalTransaccionesConfronta) && (transaction.TotalRecibos === transaction.TotalTransaccionesConfronta)
                      if( uno ){
                        cuadra = true
                      }else{
                        cuadra = false
                      }
                      return(
                        <tr key={index + 1} className='divide-x divide-grisMira'>
                          <td 
                              className={
                                `whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium sm:pl-6 
                                ${relativeIndex(index) < totalData ? 'text-grisMira' : 'bg-secundarioMira text-white'}`
                              }
                          >
                            {relativeIndex(index) < totalData ? relativeIndex(index) : 'Resumen'}
                          </td>
                          <td
                              className={
                                `whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6
                                 ${relativeIndex(index) < totalData ? null : 'bg-secundarioMira'}`
                              }
                          >
                              {relativeIndex(index) < totalData ? transaction?.Empresa : 'Total de días'}
                          </td>
                          <td 
                            className={
                              `whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6 
                              ${relativeIndex(index) < totalData ? null : 'bg-secundarioMira'}`
                            }
                          >
                              {relativeIndex(index) < totalData ? transaction?.FechaTransaccion : transaction?.FechaTransaccion}
                          </td>
                          <td 
                            className={
                              `whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6 
                              ${relativeIndex(index) < totalData ? null : 'bg-secundarioMira'}`
                            }
                          >
                              {relativeIndex(index) < totalData ? transaction?.ID : 'Total de transacciones'}
                          </td>
                              <td 
                                className={
                                  `whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6 
                                  ${relativeIndex(index) < totalData ? null : 'bg-secundarioMira'}`
                                }
                              >
                                  {relativeIndex(index) < totalData ? transaction?.Transacciones : 'Totales'}
                              </td>
                          <td 
                            className={
                              `whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6 
                              ${relativeIndex(index) < totalData ? null : 'bg-secundarioMira'}`
                            }
                          >
                              {relativeIndex(index) < totalData ? transaction?.TransaccionesConfronta : transaction?.TransaccionesConfronta}
                          </td>
                          
                          <td 
                            className={
                              `gap-2 whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pl-6 
                              ${relativeIndex(index) < totalData ? null : 'bg-secundarioMira'}`
                            }
                          >
                              {
                                cuadra 
                                ?
                                  (relativeIndex(index) < totalData ? transaction?.TotalTransacciones : transaction?.Total_Bancos)
                                :
                                <div className='flex flex-row gap-2 justify-around'>
                                  <div className={classNames(transaction.ValidaBancaVirtual?'bg-secundario' : 'bg-red-500/80' , 'w-fit px-3 py-1 rounded-xl')}>
                                    <p> {relativeIndex(index) < totalData ? transaction?.TotalTransacciones : transaction?.Total_Bancos} !!!</p>
                                  </div>
                                  {transaction.ValidaBancaVirtual? <CheckIcon className='w-5 h-5 text-green-500 my-auto'/>:<XMarkIcon className='w-5 h-5 text-red-500 my-auto'/>}
                                </div>
                              }
                          </td>



                          <td 
                            className={
                              ` whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pr-6 
                              ${relativeIndex(index) < totalData ? null : 'bg-secundarioMira'}`
                            }
                          >
                              {
                                cuadra 
                                ?
                                  (relativeIndex(index) < totalData ? transaction?.TotalRecibos : transaction?.Total_Recibos)
                                :
                                <div className='flex flex-row gap-2 justify-around'>

                                  <div className={classNames(transaction.ValidaRecibos?'bg-secundario' : 'bg-red-500/80' , 'w-fit px-3 py-1 rounded-xl')}>
                                    <p> {relativeIndex(index) < totalData ? transaction?.TotalRecibos : transaction?.Total_Recibos} !!!</p>
                                  </div>
                                  {transaction.ValidaRecibos? <CheckIcon className='w-5 h-5 text-green-500 my-auto'/>:<XMarkIcon className='w-5 h-5 text-red-500 my-auto'/>}
                                </div>
                              }
                          </td>




                          <td 
                            className={
                              ` whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-white sm:pr-6 
                              ${relativeIndex(index) < totalData ? null : 'bg-secundarioMira'}`
                            }
                          >
                              {
                                cuadra 
                                ?
                                  (relativeIndex(index) < totalData ? transaction?.TotalTransaccionesConfronta : transaction?.Total_Confronta)
                                :
                                <div className='flex flex-row gap-2 justify-around'>
                                  <div className={classNames(transaction.ValidaCertiBanco?'bg-secundario' : 'bg-red-500/80' , 'w-fit px-3 py-1 rounded-xl')}>
                                    <p> {relativeIndex(index) < totalData ? transaction?.TotalTransaccionesConfronta : transaction?.Total_Confronta} !!!</p>
                                  </div>
                                  {transaction.ValidaCertiBanco? <CheckIcon className='w-5 h-5 text-green-500 my-auto'/>:<XMarkIcon className='w-5 h-5 text-red-500 my-auto'/>}
                                </div>
                              }
                          </td>
                        </tr>
                      )
                    })
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  